import SelectPicker from './SelectPicker';
import withLocale from '../IntlProvider/withLocale';
export default withLocale(['Picker'])(SelectPicker);